export default __webpack_public_path__ + "static/media/meme.67a73861.png";